module.exports = __webpack_public_path__ + "media/images/flags/bl-002c4ac5d524b182b619dcb82bb3d63e.svg";